// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-drawer {
  width: 100%;
  height: 100%;
  background-color: var(--primary-color-light-500);
}
.navigation-drawer * + * {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Navigations/NavigationDrawer/NavigationDrawer.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,gDAAA;AACF;AACE;EACE,aAAA;AACJ","sourcesContent":[".navigation-drawer {\n  width: 100%;\n  height: 100%;\n  background-color: var(--primary-color-light-500);\n\n  * + * {\n    margin-top: 0;\n  }\n  \n  &__head {\n    \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
